export default {
    // api: "http://192.168.2.8:8087",
    // api: "http://192.168.2.17:8087",
    // 测试地址
    // api: "https://test.aiteyixia.cn",
    // 生产地址
    api: "https://yuhou.aiteyixia.cn/"
}


// WEBPACK FOOTER //
// ./src/serve.js